import { render } from "./405.vue?vue&type=template&id=f0b7756c&scoped=true"
const script = {}

import "./405.vue?vue&type=style&index=0&id=f0b7756c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0b7756c"

export default script